import styled from "@emotion/styled";

export const ListItemDescription = styled("p")`
    ${({ theme }) => theme.text.paragraph.tiny}
    position: relative;
    color: ${({ theme }) => theme.colors.primary.gunmetal["640"]};
    margin: 4px 0 0 0;
`;
